module.exports = __webpack_public_path__ + "static/media/Customers.cb49084a.svg";